module.exports = __webpack_public_path__ + "static/media/tl.0616faaa.svg";